import React from 'react';
import clsx from 'clsx';

import { FlexGridProps } from './FlexGrid.types';

export const FlexGrid = ({
  children,
  className,
  isCentered,
  hasGutters,
  shouldWrap,
  testId,
  ...htmlProps
}: FlexGridProps): JSX.Element => {
  return (
    <div
      className={clsx(
        'grid',
        {
          gutters: hasGutters,
          'grid_align-center': isCentered,
          'grid-wrap': shouldWrap,
        },
        className
      )}
      data-testid={testId}
      {...htmlProps}
    >
      {children}
    </div>
  );
};
